import { Box, Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { CoursesIds } from '../../constants';
import { CourseType } from '../../types';

export const getCourseAppearance = (courseId?: number) => {
    switch (courseId) {
        case CoursesIds.APH_ID:
            return { label: 'APH', background: '#81ABBC', foreground: '#163642' };
        case CoursesIds.CPH_ID:
            return { label: 'CPH', background: '#313E61', foreground: '#FFFFFF' };
        default:
            return { label: courseId == null ? 'Course unavailable' : 'Other course', background: '#E5E7EB', foreground: '#374151' };
    }
};

const CourseBadge = ({ course }: { course?: CourseType | null }) => {
    const appearance = getCourseAppearance(course?.id);

    return (
        <Typography
            component='span'
            title={course?.name || undefined}
            sx={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                flexShrink: 0, minWidth: 56, height: 28, px: 1.25, borderRadius: 1,
                bgcolor: appearance.background, color: appearance.foreground,
                fontSize: '0.75rem', fontWeight: 700, lineHeight: 1, letterSpacing: 0,
                whiteSpace: 'nowrap',
            }}
        >
            <Box component='span' sx={visuallyHidden}>Course: </Box>
            {appearance.label}
        </Typography>
    );
};

export default CourseBadge;